import React from "react";
import styled from "styled-components";

import colors from "../../../utils/colors";
import { rem } from "polished";
import Icon from "../../../icons/Icon";

const Wrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  margin: 2rem auto 0.5rem auto;

  ul {
    text-align: center;
    margin: 1rem auto;

    li {
      display: inline-block;
      svg {
        fill: ${colors.WHITE};
        stroke: none;
        float: left;
        width: ${rem("34px")};
        height: ${rem("34px")};
        margin-right: 1rem;
        margin-left: 1rem;
      }
    }
  }
`;

const SomeButtons = () => {
  return (
    <Wrapper>
      <ul>
        <li>
          <a href="https://www.facebook.com/mtv3suomi" target="_blank" rel="noopener noreferrer">
            <Icon icon="#facebook" />
          </a>
        </li>
        <li>
          <a href="https://twitter.com/mtv3suomi" target="_blank" rel="noopener noreferrer">
            <Icon icon="#twitter" width={rem("35px")} height={rem("35px")} />
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/mtv3suomi/" target="_blank" rel="noopener noreferrer">
            <Icon icon="#instagram" />
          </a>
        </li>
      </ul>
    </Wrapper>
  );
};

export default SomeButtons;



// WEBPACK FOOTER //
// ./src/modules/pages/components/SomeButtons.js